import { Component, ReactNode } from 'react'

import moment from 'moment'

import { 
    InsuranceDatarops, 
    AccidentType, AccidentListType, AccidentProps, AccidentErrorType, AccidentErrorList,
    BaseAccidentProps,
    ACCIDENT_NUMER 
} from "./StatusSlice"

import Incidente from './Incidente'

import Select from '../../libs/ui/inputs/Select'
import Input from '../../libs/ui/inputs/Input'

import { BaseEnumType } from '../../libs/initialization/remoteInits'

import {DATE_FORMAT, DATE_PRINT_FORMAT, isNotValidInizioPolizza } from '../../libs/validation/dateValidation'

import GenericPeople from '../people/other/GenericPeople'
import SiNo, { SiNoType, getSiNoValue, getBoolean } from "../siNo/SiNo"

import { isValidTarga, isEmpty, getMicrocarTypologyFromPlate } from "../../libs/validation/stringRegex"
import { carPlateValidation, bikePlateValidation, cc50PlateValidation } from '../../libs/validation/remoteValidationAbstract'

interface StatoAssicurativoState {
    etaAltriConducenti: BaseEnumType[]
}

class StatoAssicurativo extends Component<InsuranceDatarops, StatoAssicurativoState> {

    constructor(props: any) {
        super(props)

        this.state = {
            etaAltriConducenti: this.initEtaConducente()
        }

        this.isValidDate = this.isValidDate.bind(this)
        this.isValidTargaEreditata = this.isValidTargaEreditata.bind(this)
        this.getTargaCallBackValidatio = this.getTargaCallBackValidatio.bind(this)
        this.updateNumeroIncidenti = this.updateNumeroIncidenti.bind(this)
        this.updateIncidenti = this.updateIncidenti.bind(this)
        this.updateHaEreditatoCu = this.updateHaEreditatoCu.bind(this)
        this.updateAltriConducenti = this.updateAltriConducenti.bind(this)
        this.initAccidents = this.initAccidents.bind(this)
        this.initEtaConducente = this.initEtaConducente.bind(this)
    }

    render(): ReactNode {
        const NOW = new Date()

        const deviation = moment(NOW).add(3, 'days')
        const DATE_START = deviation.format(DATE_FORMAT)
        const DATE_END = deviation.add(1, 'months').format(DATE_FORMAT)

        const DATE_START_FORMATTED = moment(NOW).format(DATE_PRINT_FORMAT)
        const DATE_END_FORMATTED = moment(NOW).add(1, 'months').format(DATE_PRINT_FORMAT)

        const defAccidents = this.initAccidents()

        let maxTargaLength = 6 // cicolmotore
        if (this.props.tipoVeicoloEreditaCu !== undefined) {
            switch (Number (this.props.tipoVeicoloEreditaCu)) {
                case 1: // Auto
                case 2: // Moto
                case 3: // Autocarro
                    maxTargaLength = 10
                    break
                default:
                    maxTargaLength = 6 // Ciclomotore
            }
        }

        return (
            this.props.tipiStatoAssicurativo &&
            this.props.tipiFruizioneEredita &&
            this.props.tipiCuEreditata &&
            this.props.tipiCuAttuale &&
            this.props.tipiAnzianitaPrimaClasse &&
            this.props.tipiCompagnieAttuali &&
            this.props.tipiEtaAssicurativa &&
            this.props.tipiAnniIncidenti &&
            this.props.tipiResponsabilitaIncidenti &&
            this.props.tipiRelazioniPersone &&
            <>
                <Input 
                    label='Data di decorrenza nuova polizza'
                    id='data_decorrenza' name='data_decorrenza' key='data_decorrenza'
                    type='date'
                    value={this.props.dataScadenza}
                    min={DATE_START}
                    max={DATE_END}
                    callback={this.props.updateDataScadenza}
                    errorDisplayMsg={'tra ' + DATE_START_FORMATTED + ' e ' + DATE_END_FORMATTED}
                    regexp={this.isValidDate}
                    error={this.props.dataScadenzaError}
                    ingoreLostFocus={true}
                />

                <Select
                    id='stato_Assicurativo' name='stato_Assicurativo' key='stato_Assicurativo'
                    label='Il veicolo è' 
                    value={this.props.statoAssicurativo}
                    options={this.props.tipiStatoAssicurativo}
                    callback={this.props.updateStatoAssicurativoCallBack}
                    error={this.props.statoAssicurativoError}
                />

                { this.props.statoAssicurativo === 'assicurataAMioNome' &&
                    <>
                        <Select
                            id='cuAttuale' name='cuAttuale' key='cuAttuale'
                            label='Classe di merito di assegnazione' 
                            value={this.props.cuAttuale?.toString()}
                            options={this.props.tipiCuAttuale}
                            callback={this.props.updateCuAttualeCallBack}
                            error={this.props.cuAttualeError}
                            forceSortById={true}
                        />

                        { (this.props.cuAttuale !== undefined && Number (this.props.cuAttuale) === -1) &&
                            <Select
                                id='anzianita_Prima_Classe' name='anzianita_Prima_Classe' key='anzianita_Prima_Classe'
                                label='Da quanti anni sei in classe 1?' 
                                value={this.props.anzianitaPrimaClasse?.toString()}
                                options={this.props.tipiAnzianitaPrimaClasse}
                                callback={this.props.updateAnzianitaPrimaClasseCallBack}
                                error={this.props.anzianitaPrimaClasseError}
                            />
                        }

                        <Select
                            id='compagnia_Attuale' name='compagnia_Attuale' key='compagnia_Attuale'
                            label='Compagnia assicurativa attuale' 
                            value={this.props.compagniaAttuale?.toString()}
                            options={this.props.tipiCompagnieAttuali}
                            callback={this.props.updateCompagniaAttualeIdCallBack}
                            error={this.props.compagniaAttualeError}
                            forceSortByLabel={true}
                        />

                        <Select
                            id='eta_Assicurativa' name='eta_Assicurativa' key='eta_Assicurativa'
                            label='Da quanti anni sei assicurato?' 
                            value={this.props.etaAssicurativa?.toString()}
                            options={this.props.tipiEtaAssicurativa}
                            callback={this.props.updateEtaAssicurativaCallBack}
                            error={this.props.etaAssicurativaError}
                        />

                        <Select
                            id='numero_Incidenti' name='numero_Incidenti' key='numero_Incidenti'
                            label='Quanti incidenti hai avuto (con e/o senza colpa)?'
                            value={this.props.numeroIncidenti?.toString()}
                            options={ACCIDENT_NUMER}
                            callback={this.updateNumeroIncidenti}
                            error={this.props.numeroIncidentiError}
                        />

                        { (this.props.numeroIncidenti !== undefined && Number(this.props.numeroIncidenti) > 0) &&
                            <div id='accidents-group'>
                                { 
                                    defAccidents.map( (ele: AccidentProps, i: number) => 
                                        <Incidente 
                                            incidente={ele.incidente}
                                            incidenteError={ele.incidenteError}

                                            updateIncidente={this.updateIncidenti}

                                            tipiAnno={this.props.tipiAnniIncidenti}
                                            tipiResponsabilita={this.props.tipiResponsabilitaIncidenti}

                                            key={i}
                                        />
                                    )

                                }
                            </div>
                        }

                        <SiNo 
                            id='haEreditatoCu' name='haEreditatoCu' key='haEreditatoCu'
                            label='Hai ereditato la classe di merito?'
                            value={ getSiNoValue( this.props.haEreditatoCu ) }
                            callback={this.updateHaEreditatoCu}
                            error={this.props.haEreditatoCuError}
                        />
                    </>
                }

                { (this.props.statoAssicurativo !== undefined && this.props.statoAssicurativo !== 'assicurataAMioNome') &&
                    <>
                        <Select
                            id='tipo_Eredita_Cu' name='tipo_Eredita_Cu' key='tipo_Eredita_Cu'
                            label="Vuoi usare l'attestato di rischio di un altro veicolo? (RC Familiare / Decreto Bersani)"
                            value={this.props.tipoEreditaCu?.toString()}
                            options={this.props.tipiFruizioneEredita}
                            callback={this.props.updateTipoEreditaCuCallBack}
                            error={this.props.tipoEreditaCuError}
                        />

                        { (this.props.tipoEreditaCu !== undefined && Number(this.props.tipoEreditaCu) > 1) && // NO == 1
                            <>
                                <Select
                                    id='cuAttuale' name='cuAttuale' key='cuAttuale'
                                    label="Classe di merito di assegnazione dell'altro veicolo"
                                    value={this.props.cuEreditata?.toString()}
                                    options={this.props.tipiCuEreditata}
                                    callback={this.props.updateCuEreditataCallBack}
                                    error={this.props.cuEreditataError}
                                />

                                <Select
                                    id='tipoVeicoloEreditaCu' name='tipoVeicoloEreditaCu' key='tipoVeicoloEreditaCu'
                                    label="Tipologia dell'altro veicolo"
                                    value={this.props.tipoVeicoloEreditaCu?.toString()}
                                    options={this.props.tipiVeicoloEretiaCu}
                                    callback={this.props.updateTipoVeicoloEreditaCuCallBack}
                                    error={this.props.tipoVeicoloEreditaCuError}
                                />

                                {this.props.tipoVeicoloEreditaCu !== undefined && 
                                    <Input 
                                        id='targa_cu' name='targa_cu' key='targa_cu'
                                        label="Targa dell'altro veicolo (da cui erediti la classe)"
                                        value={this.props.targaCu}
                                        type='text'
                                        maxLength={maxTargaLength}
                                        callback={this.props.updateTargaCuCallBack}
                                        regexp={this.isValidTargaEreditata}
                                        remoteValidation={this.getTargaCallBackValidatio()}
                                        errorDisplayMsg='Targa non valida'
                                        error={this.props.targaCuError}
                                    />
                                }
                            </>
                        }
                    </>
                }

                { this.props.showOwner &&
                    <div className='peopleSection'>
                        <h2>Il proprietario</h2>

                        <Select
                            id='relazione_proprietario' name='relazione_proprietario' key='relazione_proprietario'
                            label='Il proprietario e il contraente del veicolo coincidono?' 
                            value={this.props.isSameContractorOwner?.toString()}
                            options={this.props.tipiRelazioniPersone}
                            callback={this.props.updateIsSameContractorOwnerCallBack}
                            error={this.props.isSameContractorOwnerError}
                        />

                        { this.props.isSameContractorOwner !== undefined && Number(this.props.isSameContractorOwner) > 1 &&
                            <GenericPeople 
                                contractor={this.props.contractor}
                                people={this.props.owner}
                                peopleRole='proprietario'
                                user={this.props.user} 

                                error={this.props.ownerError} 

                                updatePeopleCallback={this.props.updateOwnerCallBack} 
                                updateUserCallBack={this.props.updateUserCallBack} 
                                expiredSessionCallbak={this.props.manageExpiredSessionsCallBack}
                            />
                        }
                    </div>
                }

                <div className='altriConducentiSection'>
                    <h2>Il conducente</h2>
                    <SiNo 
                        id='altriConducenti' name='altriConducenti' key='altriConducenti'
                        label='Ci sono altri conducenti?'
                        value={ getSiNoValue( this.props.altriConducenti ) }
                        callback={this.updateAltriConducenti}
                        error={this.props.altriConducentiError}
                    />

                    { this.props.altriConducenti === true &&
                        <Select
                            id='etaConducentePiuGiovane' name='etaConducentePiuGiovane' key='etaConducentePiuGiovane'
                            label="Età del conducente più giovane"
                            value={this.props.etaConducentePiuGiovane?.toString()}
                            options={this.state.etaAltriConducenti}
                            callback={this.props.updateEtaConducentePiuGiovaneCallBack}
                            error={this.props.etaConducentePiuGiovaneError}
                        />
                    }
                </div>
            </>
        )
    }

    private isValidDate (date: string) {
        if (this.props.statoAssicurativo === 'assicurataAMioNome') {
            return !isNotValidInizioPolizza( date )
        }

        return true
    }

    private isValidTargaEreditata (targa: string | undefined) {
        return isValidTarga(targa, this.props.tipoVeicoloEreditaCu)
    }

    /**
     * PARTICOLARITA js: 
     * questa funzione ritona la funzione da utilizzare per la validazione remota della targa, 
     * in base alla tipologia di veicolo selezionata
     * 
     * @returns la funzione da usare per la validazione remota di una targa
     */
    private getTargaCallBackValidatio () {
        switch (Number(this.props.tipoVeicoloEreditaCu) || 0) {
            case 1: // Auto
            case 3: // Autocarro
                return carPlateValidation
            case 2: // Moto
                return bikePlateValidation
            default: // Ciclomotore o NaN (default)
                return (getMicrocarTypologyFromPlate(this.props.targaCu) === 'quadriciclo')
                    ? bikePlateValidation
                    : cc50PlateValidation
        }
    }

    private updateNumeroIncidenti (val: string | undefined) {
        if (this.props.updateNumeroIncidentiCallBack) {
            let next = (val !== undefined) ? Number (val) : val

            this.props.updateNumeroIncidentiCallBack( next )
        }
    }

    private updateHaEreditatoCu (val : SiNoType) {
        this.props.updateHaEreditatoCuCallBack (
            getBoolean( val )
        )
    }

    private updateAltriConducenti (val : SiNoType) {
        this.props.updateAltriConducentiCallBack (
            getBoolean( val )
        )
    }

    /**
     * Mi aspeto di ricevere 
     *  this.props.incidenti = [{ anno: string | undefined, responsabilita: string | undefined, numero: number } ... ]
     *  this.props.incidentiError = [{numero: number, error: string | undefined} ...]
     *  
     * @returns la lista inizializzata
     */
    private initAccidents () {
        const propsAccidents = (this.props.incidenti ?? [])
        const errorAccidents = (this.props.incidentiError ?? [])

        const initAccidents: any = []
        const initErrors: any = []

        if (errorAccidents.length === 0 && propsAccidents.length > 0) {
            // non ho ricevuto errori li devo ricalcolare
            propsAccidents.forEach( 
                (acc: AccidentType) => initErrors.push({
                    numero: acc.numero,
                    error: (isEmpty(acc.anno) || isEmpty(acc.responsabilita) ? 'Valore non valido' : undefined),
                })
            )
        } 
        else {
            errorAccidents.forEach (
                (error : AccidentErrorType) => initErrors.push( error )
            )
        }
      
        // manipolo gli incidenti ricevuti con le props
        propsAccidents.forEach( 
            (acc: AccidentType) => initAccidents.push({
                incidente: acc,
                incidenteError: initErrors.filter( (err: AccidentErrorType) => err.numero === acc.numero)?.pop(),
            })
        )

        for (let i = propsAccidents.length; i < (this.props.numeroIncidenti ?? 0); i++) {
            initAccidents.push({
                incidente: {anno: undefined, responsabilita: undefined, numero: i},
                incidenteError: {
                    numero: i, 
                    error: initErrors.filter( (err: AccidentErrorType) => err.numero === i)?.pop()?.error
                },
            })
        }

        return initAccidents        
    }

    private initEtaConducente () {
        const computedListaEtaConducente : BaseEnumType[] = []
        for (let i = Number(this.props.etaMinimaConducente); i <= 29; i++) {
            const tmp = i.toString()

            computedListaEtaConducente.push({
                id: tmp, value: tmp
            })
        }
        computedListaEtaConducente.push({
            id: "30", value: "30 o più"
        })

        return computedListaEtaConducente
    }

    private updateIncidenti (val: AccidentType) {
        const accidentNumber = val.numero

        let accProps: any[] = this.initAccidents()

        const index = accProps.findIndex( (acc: BaseAccidentProps) => acc.incidente.numero === accidentNumber)

        if (index >= 0) {
            // sovrascrivo il vecchio..
            accProps[index].incidente = val
            accProps[index].incidenteError = undefined            
        }
        else {
            // aggiungo il nuovo
            accProps.push({
                incidente: val,
                incidenteError: undefined
            })
        }

        const nextAccidents: AccidentListType = []
        const nextErrors: AccidentErrorList = []

        accProps.forEach ( (acc: BaseAccidentProps) => nextAccidents.push(acc.incidente) )
        accProps.forEach ( (acc: BaseAccidentProps) => nextErrors.push(acc.incidenteError) )
        
        const filterdErrors = nextErrors.filter ( (err: AccidentErrorType) => err !== undefined && err.numero !== accidentNumber )

        // aggiorno
        this.props.updateIncidentiCallBack ( nextAccidents, filterdErrors )

    }
}

export default StatoAssicurativo